/** @format */

import React from 'react';
import '../css/Header.css';

import blender from '../images/Imagen 7.png';

import avatarTeacher from '../images/logo_dot.png';
import Tags from './buttons/Tags';
import dayjs from 'dayjs';
import Countdown from './Countdown';

import { useDispatch } from 'react-redux';

import { openCounseling } from '../features/counseling';
import { openVideo } from '../features/video';
import { openQuestion } from '../features/question';

import BulletPointBlink from './buttons/BulletPointBlink';
import BulletPoint from './buttons/BulletPoint';

import Image from 'react-image-webp';

import image from '../images/3d-isolated.png';
import imageWebp from '../images/3d-isolated.webp';

import backgroundRight from '../images/2-resize.jpg';
import backgroundRightWebp from '../images/2-resize.webp';

import backgroundLeftResize from '../images/1-resize.jpg';
import backgroundLeftWebpResize from '../images/1-resize.webp';

import underline from '../images/underline.png';
import { IoHelpCircle } from 'react-icons/io5';

const countdown = 'Thu, 10 Nov 2022 16:00:00 GMT-5';

const Header = () => {
  const nowDay = dayjs();
  const openingDay = dayjs(countdown);

  const dispatch = useDispatch();

  const benefits = [
    <p>Feedback en vivo.</p>,
    <p>Material de ayuda.</p>,
    <p>Certificado.</p>,
    <p style={{ display: 'flex', alignItems: 'center' }}>
      Acceso 1 año{' '}
      <IoHelpCircle
        style={{ color: '#6000de', cursor: 'pointer', marginLeft: 5 }}
        onClick={() => {
          dispatch(openQuestion());
        }}>
        ?
      </IoHelpCircle>
    </p>,
  ];

  const handleClink = (e) => {
    e.preventDefault();
    const target = e.target.getAttribute('href');
    const location = document.querySelector(target).offsetTop;
    window.scrollTo({
      left: 0,
      top: location - 80,
    });
  };

  return (
    <section className='Header' id='home'>
      <div className='header-background'>
        <div className='left'>
          <Image
            src={backgroundLeftResize}
            webp={backgroundLeftWebpResize}
            alt='background'
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
              position: 'relative',
              left: '-10%',
            }}
          />
        </div>
        <div className='right'>
          <Image
            src={backgroundRight}
            webp={backgroundRightWebp}
            alt='background'
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'cover',
            }}
          />
        </div>
      </div>
      <div className='header-filter'></div>
      <div className='header-container container '>
        <div className='header-content padding'>
          <Image
            src={image}
            webp={imageWebp}
            alt='Máster en Blender'
            className='header-image'
          />
          <div className='header-item'>
            <BulletPoint color={'#77bf41'} />
            <p style={{ textShadow: '0 0 10px rgba(0, 0, 0, 1)' }}>
            Domina Blender
            </p>
          </div>
          <h1 className='header-title'>
            DOS MESES
            <br />
            <span>
              INTENSIVOS
              <img
                src={underline}
                alt='underline'
                className='underline'
              />
            </span>
          </h1>
          <div className='master-benefits'>
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className='header-item'
                style={{ fontWeight: 'normal' }}>
                <BulletPoint color={'#6000de'} />
                {benefit}
              </div>
            ))}
          </div>
          <div className='header-buttons'>
            <button
              className='header-button see-trailer'
              onClick={() => {
                dispatch(
                  openVideo({
                    modal: true,
                    url: 'https://www.youtube.com/watch?v=VXvaSAsrJw8',
                    type: 'common',
                  })
                );
              }}>
              VER TRAILER
            </button>

            <a
              href='https://www.dropbox.com/s/q8k8hceo4kwdb9n/LittleDragon_With_Cover%20Libel%20Academy.pdf?dl=0'
              target='_blank'
              rel='noreferrer'
              className='header-button see-payment'
              style={{ textTransform: 'uppercase' }}>
              Ver Temario
            </a>
          </div>
        </div>
        <div className='header-information'>
          <div className='header-information-content'>
            <img src={avatarTeacher} alt='Avatar Teacher' />
            <p className='teacher' style={{ textAlign: 'center' }}>
              <span>Profesor:</span>
              <br />
              Ricardo Díaz
            </p>
            <h2>
              Orientado para
              <br />
              Jóvenes y Adultos
            </h2>
            <Tags name={'¿Preguntas?'}  />
            {openingDay.isAfter(nowDay) ? (
              <Countdown countdownTimestampMs={countdown} />
            ) : (
              <h3 className='start-master'>
                <BulletPointBlink color={'#77bf41'} />
                <span>Inicia de inmediato</span>
              </h3>
            )}
            <a
              href='#entrenamientos'
              className='payment'
              onClick={handleClink}>
              Aparta tu cupo
            </a>
            <button
              className='to-payment-methods'
              onClick={() => {
                dispatch(openCounseling());
              }}>
              ¡ PREGUNTAS !
            </button>
            <a
              href='#services'
              className='payment-information'
              onClick={handleClink}>
              Ver método de estudio
            </a>
          </div>
          <div className='header-information-technologies'>
            <img src={blender} alt='blender' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
